module.exports = __webpack_public_path__ + "img/pic2.853627f9.png";